import {
  VALIDATIONS,
  SHOWBUTTONNAVIGATION,
  ORDERFROMTRACKING
} from "../Types";

export const setValidations = (payload) => {
  return {
    type: VALIDATIONS,
    payload: payload,
  };
};
export const setShowButtonNavigation = (payload) => {
  return {
    type: SHOWBUTTONNAVIGATION,
    payload: payload,
  };
};

export const setOrderFromTracking = (payload) => {
  return {
    type: ORDERFROMTRACKING,
    payload: payload,
  };
};
